import React from "react";

type SetHasReactionChanged = React.Dispatch<React.SetStateAction<boolean>>;
export const SetHasReactionChangedContext = React.createContext<{
  setHasReactionChanged: SetHasReactionChanged | null;
}>({ setHasReactionChanged: () => null });
export const useSetHasReactionChanged = () =>
  React.useContext(SetHasReactionChangedContext);
